import styled, { css } from 'styled-components';
import { Title } from '@lux/title';
import { mediaMinWidth } from '@lux/templates';
import { Spacer } from '@lux/tokens';

import { Screen, screenSmallerThan } from '@client/styles/styled-components/breakpoints';

export const OuterWrapper = styled.main`
    background-color: #f7f7f7;
    position: relative;
    .grid-page-layout {
        ${screenSmallerThan(Screen.smallTablet)} {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;

export const Wrapper = styled.section<{ $isLastContainer?: boolean }>`
    position: relative;
    background-color: #f7f7f7;
    ${({ $isLastContainer }) =>
        $isLastContainer &&
        css`
            padding-bottom: 35px;
        `};
`;

export const InlineFlashMessage = styled.div`
    margin: 0 3% 15px;
`;

export const UpcomingTitle = styled(Title)`
    margin-top: ${Spacer.XL};
    padding: 0 14px;
    ${mediaMinWidth.sm} {
        padding: 0;
    }
`;
